import { Box, Button, Checkbox, IconButton, InputBase } from "@mui/material"
import { List } from "./List"
import { useContext, useEffect, useState } from "react"
import { ThreeDots } from "../modal/ThreeDots"
import { FileInfo } from "../modal/FileInfo"
import { ToolContext } from "../../../../../core/context/ToolContext"
import CloseIcon from '@mui/icons-material/Close';
import { SearchIcons } from "../../../../../core/global/Icons"
import { Loader } from "../../../../fetching/Loader"
import { NoFound } from "../../../../mycloud/global/DesktopDsg"
import { NoResult } from "../../../../empty/Index"
import { Confirmation, NewSuccessAlert } from "../../../../../core/global/forms/CstmModal"
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank } from "@mui/icons-material"
import { CreateVersion } from "../modal/CreateVersion"
import {
    agreeGuidelineVersions, readGuidelines, updateGuidelineVersion, viewGuidelineVersion
} from "../../../api/guidelines"

let uai_user = process.env.REACT_APP_UAI_REGULAR;

export const ListIndex = ({SendFeatureLogs, deptStaticData }) => {

    const { policy_state, tool_state, cloud_state } = useContext(ToolContext)
    const { plcyData, successOpen, message,  isLoading } = policy_state
    const { inftScroll, lid } = cloud_state
    const { __SESSION } = tool_state
    const uid = atob(__SESSION.data.ainfo.aid).split('_', 2)[1];

    const icon = <CheckBoxOutlineBlank fontSize="small" sx={{color: '#11783C', borderRadius: '50%'}} />;
    const checkedIcon = <CheckBoxIcon fontSize="small" sx={{color: '#11783C', borderRadius: '50%'}} />;

    const [pModal, setPModal] = useState({
        update: false,
        view: false,
        fullview: false,
        fileview: false,
        remove: false,
        id:'',
        loader:false,
        data:[],
        agreeinfo: [],
        list: false,
        count: 0,
        agreelist: false,
        createVersion: false,
        viewLoader: false
    })
    
    const [selectAll, setSelectAll] = useState(false)
    const [checkStat, setCheckStat] = useState('')
    const [acknowledgementChecked, setAcknowledgementChecked] = useState(false)
    const versionToIssue = pModal.selectedVersion || pModal.data[0]
    const issueMessage = (versionToIssue?.version_number || 1) === 1 ?
        'Update Guideline Status to Issued?' :
        `Issue Version ${versionToIssue.version_number} of this Guideline?`
    const handleSubmit = async() => {
        setPModal({...pModal, loader:true})

        let filter = pModal.remove ? 'remove' : 'issue'
        let res = await updateGuidelineVersion({
            id: pModal.id,
            userId: parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]),
            remove: pModal.remove
        })

        if (res.message === 'success') {
            SendFeatureLogs(3)
            if (filter === 'issue'){
                message.set('Successfully Updated.')
            }else{
                message.set('Successfully Removed.')
            }
            plcyData.set([])
            await __init(0, '')
            setPModal({...pModal, update: false, loader:false, remove: false,
                fullview: false, data: [], selectedVersion: null})
            successOpen.set(true)
            
        }
    }

    const handleCancel = () => {
        setPModal({...pModal, update: false, remove: false})
    }

    const handleClick = async(type, data)  => {
        const source = data?.data?.[0] || data
        const sourceId = source?.id
        setPModal((prev) => ({
            ...prev,
            [type]: true,
            id: type === 'fullview' && prev.fullview ? prev.id : sourceId,
            cp_status: source?.cp_status ?? data?.cp_status,
            viewLoader: type === 'fullview' || type === 'fileview'
        }))
        
        if (type === 'view' || type === 'fullview' || type === 'fileview' || type === 'agreelist') {
            try {
                let res = await viewGuidelineVersion(sourceId)
                let detail = Array.isArray(res) ? res[0] : res
                let mergeArray = detail ? [detail].map(pd => {
                    let fltrDept = deptStaticData?.find(dd => pd.company_department_id === dd.id)
                    return {
                        ...pd,
                        policyname: pd.policyname || pd.policy_name || source.policy_name,
                        policy_num: pd.policy_num || source.policy_num,
                        versions: detail.versions || [],
                        dept_name: fltrDept?.name || pd.dept_name || source.dept_name,
                        approved_name: pd.approved_name || source.approved_name || '',
                        prepared_name: pd.prepared_name || source.prepared_name || '',
                        cp_status: source.cp_status
                    }
                }) : []
                if (mergeArray.length > 0) {
                    setPModal((prev) => ({...prev, data:mergeArray, id:sourceId, viewLoader:false}))
                }
            } finally {
                setPModal((prev) => ({...prev, viewLoader:false}))
            }
        }
    }

    const __init = async(val, search) => {
        if (atob(__SESSION.data.ainfo.aid).split('_', 2)[1] !== '0') {
            if (val === 0) {
                isLoading.set(true)
                inftScroll.set(true)
            }
            if (val !== undefined) {
                let deptid = []
                const res_deptid = deptStaticData?.filter((item) =>
                    __SESSION.data.uaccess[0].role_id === parseInt(uai_user) ?
                        item.name.toLowerCase().match(search.toLowerCase()) && (item.id === __SESSION.data.uaccess[0].company_department_id || item.id === 0)
                    :
                        item.name.toLowerCase().match(search.toLowerCase())
                );
                if (res_deptid.length > 0) {
                    res_deptid.filter((v) => { return deptid.push(v.id) })
                }
    
                let res = await readGuidelines({
                    isRegular: __SESSION.data.uaccess[0].role_id === parseInt(uai_user),
                    companyId: __SESSION.data.uaccess[0].company_id,
                    lastId:val, 
                    limit:20,
                    filter:search,
                    departmentIds: deptid,
                    departmentOwnedId: __SESSION.data.uaccess[0].company_department_id,
                    userId: parseInt(uid)
                })

                if (res === 0 || !Array.isArray(res) || res.length === 0) {
                    if (val === 0 || search !== '') {
                        plcyData.set([])
                    }
                    lid.set(0)
                    inftScroll.set(false)
                    isLoading.set(false)
                    return
                }

                if (res){
                    let l_id;   
                    for (let i = 0; i < res.length; i++) { l_id = res[i].id}
                    lid.set(l_id);
                    if (l_id === 1 || res.length !== 20 ) {
                        inftScroll.set(false);
                    }
    
                    let mergeArray = res.map(pd => {
                        let fltrDept = deptStaticData?.find(dd => { return pd.company_department_id === dd.id })
                        return {
                            ...pd,
                            policy_name: pd.policy_name || pd.policyname,
                            issue_date: pd.issue_date || pd.dateissued,
                            version_number: pd.version_number || 1,
                            dept_name:fltrDept?.name || pd.dept_name || 'All',
                            stat: selectAll
                        }
                    })
                    if (__SESSION.data.uaccess[0].role_id === parseInt(uai_user)) {
                        mergeArray.sort((a, b) => new Date(b.issue_date || 0) - new Date(a.issue_date || 0) || b.id - a.id)
                    }
                    // sort((a, b) => a.dept_name.localeCompare(b.dept_name))
                    if (search !== '') {
                        plcyData.set(mergeArray);
                    }else {
                        plcyData.set((prev) => [...prev, ...mergeArray]);
                    }
                    isLoading.set(false)
                }
            }
        }
    }

    // FOR SEARCH
    const [pSearch, setPSearch] = useState('');
    const [search, setSearch] = useState(false)
    const handlerSearch = () => {
        setSearch(!search)
    }

    const handlerCloseSearch = () => {
        setSearch(false)
        setPSearch('')
    }
    
    // const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z0-9-]+$/;
    const handleSearch = (e) => {
        if (!isLoading.data) {
            isLoading.set(true)
        }
        setPSearch(e.target.value)
    }

    const loadMoreData = () => {
        __init(lid.data, pSearch)
    }

    const searchData = async() => {
        __init(0, pSearch)
    }

    const handleCheckChange = (e, value) => {
        setAcknowledgementChecked(false)
        setCheckStat(value === 'ALL' ? 0 : 1)
    
        if (value === 'ALL') {
            const newValue = !selectAll
            setSelectAll(newValue)
            let statmap = plcyData.data.map(v => ({...v, stat: v.cp_status !== 3 ? newValue : v.stat}))
            plcyData.set(statmap)
        } else {
            let updatedData = plcyData.data.map(v => v.id === value.id ? {...v, stat: e.target.checked} : v)
            plcyData.set(updatedData)

            // Check if Child Checkbooxes are all checked
            const allChecked = updatedData.filter(v => v.cp_status !== 3).every(v => v.stat);
            setSelectAll(allChecked)
        }
    }

    const handleClickAgree = async(id) => {
        let ids = checkStat === 0 ? 'all' : []
        if (id === 'check') {
            if (checkStat !== 0) {
                let fltr = plcyData.data.filter(v => { return v.stat} )
                fltr.map(v => { return ids.push({cpid:v.id, status:3}) })
            }else{
                setSelectAll(!selectAll)
            }
        }else{
            ids.push({cpid:id, status:3})
        }
        
        let res = await agreeGuidelineVersions({
            companyId: __SESSION.data.uaccess[0].company_id,
            departmentId: __SESSION.data.uaccess[0].company_department_id,
            ids,
            userId: parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1])
        })
        if (res.message === 'success') {
            SendFeatureLogs(3)
            plcyData.set([])
            __init(0, '')
            message.set('Successfully acknowledged Guideline.')
            successOpen.set(true)
            if (pModal.view || pModal.fullview) {
                setPModal((prev) => ({...prev, cp_status:3}))
            }
            setAcknowledgementChecked(false)
        }
    }

    useEffect(() => {
        if (pSearch === '' && atob(__SESSION.data.ainfo.aid).split('_', 2)[1] !== '0') {
            plcyData.set([]);
            __init(0, '')
        } else {
            const searchFunction = setTimeout(() => {
                searchData()
            }, 800);
            return () => clearTimeout(searchFunction)
        }
        // eslint-disable-next-line
    },[pSearch])

    return (
        <Box height="100%" bgcolor="#F0F5F9" display="flex" flexDirection="column" >
            <Box minHeight="44px" width="100%" display="flex" alignItems="center" px={2} justifyContent="space-between" >
                {
                    search && (
                        <>  
                            <IconButton color="inherit" onClick={handlerCloseSearch}>
                                <CloseIcon />
                            </IconButton>
                            <InputBase 
                                fullWidth
                                // onKeyDown={(event) => {
                                //     if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                //     event.preventDefault();
                                //     }
                                // }}
                                onPaste={(e)=>{
                                    e.preventDefault()
                                    return false;
                                }} 
                                onCopy={(e)=>{
                                    e.preventDefault()
                                    return false;
                                }}
                                value={pSearch}
                                onChange={(e) => handleSearch(e)}
                                placeholder="Search"
                                inputProps={{ 'aria-label': 'search' }}
                                sx={{border: "#107038 solid 2px", borderRadius: '10px', padding: '5px', height: '40px'}}

                            />
                        </>
                    )
                }
                {
                    !search && (
                        <Box fontSize="16px" fontWeight="600" lineHeight="26px">Guidelines</Box>
                    )
                }
                <Box width="50px" height="100%" display="flex" justifyContent="flex-end" onClick={handlerSearch}>
                    <IconButton>
                        <SearchIcons />
                    </IconButton>
                </Box>
            </Box>
            {
                __SESSION.data.uaccess[0].role_id === parseInt(uai_user) && plcyData.data.some(v => v.cp_status !== 3) && (
                <Box minHeight="20px" width="100%" display="flex" alignItems="center" bgcolor="#FFFFFF" p="8px 12px" borderBottom="1px #E6E6E6 solid">
                    <Checkbox icon={icon} checkedIcon={checkedIcon} sx={{p: '0px', pr:'4px'}} checked={selectAll} onChange={(e) => handleCheckChange (e, 'ALL')}></Checkbox>
                    <Box fontSize="14px" fontWeight={400} lineHeight="19px" color="#333333" pl={1}>Select All</Box>
                </Box>
                )
            }
            <Box height="100%" sx={{ overflowY: 'auto'}} bgcolor="#FFFFFF" p={1}>
            {
                isLoading.data ?
                <Loader />
            :
                plcyData.data.length === 0 ?
                    pSearch === '' ?
                    <NoFound msg={__SESSION.data.uaccess[0].role_id === parseInt(uai_user) ?
                        'No Guideline Found.' : 'No Guideline Found. Upload Now!'}/>
                    :
                    <NoResult />
                :
                <List handleClick={handleClick} plcyData={plcyData} __SESSION={__SESSION} inftScroll={inftScroll} loadMoreData={loadMoreData} handleCheckChange={handleCheckChange} checkedIcon={checkedIcon} icon={icon} /> 
            }
            </Box>
            {
                __SESSION.data.uaccess[0].role_id === parseInt(uai_user) && plcyData.data.some(v => v.cp_status !== 3 && v.stat) && (
                    <Box minHeight="150px" display="flex" justifyContent="center" flexDirection="column" alignItems="center" pb={1} pt={2} bgcolor="#FFFFFF">
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="row" p={1} gap="8px" fontSize="12px" fontWeight={400} lineHeight="20px">
                            <Checkbox checked={acknowledgementChecked}
                                onChange={event => setAcknowledgementChecked(event.target.checked)}
                                sx={{height: '20px', width: '20px'}} />
                            <Box>I acknowledge that I have read this guideline in its entirety and will seek clarification for anything I do not understand.</Box>
                        </Box>
                        <Box display="flex" justifyContent="center" color="#00B74C" fontSize="20px" fontWeight={600} lineHeight="16px" bgcolor="#00be811f" borderRadius="10px" height="40px" width="250px">
                            <Button disabled={!acknowledgementChecked}
                                onClick={() => handleClickAgree ('check')}>Understood and Agree</Button>
                        </Box>
                    </Box>
                )
            }
            {(pModal.view && pModal.data.length > 0 ) &&
                <ThreeDots pModal={pModal} setPModal={setPModal} __SESSION={__SESSION} handleSubmit={handleSubmit} />
            }

            {(pModal.fullview && pModal.data.length > 0 ) &&
                <FileInfo pModal={pModal} setPModal={setPModal} isLoading={isLoading}
                    __SESSION={__SESSION} handleClick={handleClick} handleClickAgree={handleClickAgree}
                    onCreateVersion={() => setPModal(prev => ({ ...prev, createVersion: true }))}
                    onIssueVersion={version => setPModal(prev => ({
                        ...prev, id: version.id, selectedVersion: version, update: true
                    }))} />
            }
            <CreateVersion open={pModal.createVersion} guideline={pModal.data[0]}
                onClose={() => setPModal(prev => ({ ...prev, createVersion: false }))}
                onCreated={async() => {
                    setPModal(prev => ({ ...prev, createVersion: false, fullview: false, data: [] }))
                    plcyData.set([])
                    await __init(0, '')
                    message.set('Successfully created guideline version.')
                    successOpen.set(true)
                }} />
            {successOpen.data && 
                <NewSuccessAlert successOpen={successOpen.data} setSuccessOpen={successOpen.set} text={message.data} />
            }
            {(pModal.update || pModal.remove) && 
                <Confirmation isOpen={pModal.update || pModal.remove} disabled={pModal.loader}
                    message={pModal.update ? issueMessage :
                        'Once you remove this guideline you will not be able to access it again.'}
                    text={pModal.update ? 'Issue' : 'Remove'} proceedBtn={() => handleSubmit()}
                    cancelBtn={() => handleCancel()}/>
            }
        </Box>
    )
}
